import { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { CustomSupplierListItem } from "src/components/denseForm/customListItem/customSupplier";
import MenuAutocompleteV2 from "src/components/denseForm/MenuAutocompleteV2";
import useLocales from "src/hooks/useLocales";
import useSupplier from "src/pages/ManualDocumentV2/hooks/useSupplier";
import type { IFieldConfig } from "../../types";
import { handleCompanySelect } from "./utils/handleCompanySelect";

interface IVendorLookupFieldProps {
  config: IFieldConfig;
}

const VendorLookupField = ({ config }: IVendorLookupFieldProps) => {
  const { translate } = useLocales();
  const {
    watch,
    setValue,
    trigger,
    formState: { errors },
  } = useFormContext();

  const companyName = watch(config.name);
  const { selectOption, setSelectOption, ...rest } = useSupplier({
    label: companyName,
    value: companyName,
  });

  useEffect(() => {
    if (companyName !== selectOption?.label) {
      setSelectOption({ label: companyName, value: companyName });
    }
  }, [companyName, setSelectOption, selectOption?.label]);

  return (
    <MenuAutocompleteV2
      optionTitle={translate("Vendor")}
      getOptionLabel={(option: any) => option?.label ?? ""}
      error={(errors as any).vendorCompanyName?.message}
      onInputChange={(e) => {
        const v = e?.target.value ?? "";
        setSelectOption({ label: v, value: v });
        setValue("vendorCompanyName", v);
      }}
      onChange={(_, newValue) => {
        handleCompanySelect({
          newValue,
          prefix: "vendor",
          setValue,
          trigger,
          setSelectOption,
        });
      }}
      {...rest}
      renderOption={(props, option) => (
        <CustomSupplierListItem {...props} option={option} />
      )}
      renderOptionHeader={() => null}
      value={selectOption}
      onSearch={rest.getAsyncOptions}
      enableSearch
      label={translate(config.label)}
    />
  );
};

export default VendorLookupField;
